import React from "react";
import PropTypes from "prop-types";

const IconWithLabel = props => (
    <div
        className={`icon-with-label ${props.onClick ? "is-link" : ""}`}
        onClick={props.onClick}
    >
        <svg
            aria-hidden="true"
            focusable="false"
            className={`pe-icon--${props.icon}`}
        >
            <title>{props.label}</title>
            <use xlinkHref={`#${props.icon}`} />
        </svg>
        <span>{props.label}</span>
    </div>
);

IconWithLabel.propTypes = {
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
};

export default IconWithLabel;



// WEBPACK FOOTER //
// ./src/components/widgets/IconWithLabel/IconWithLabel.js